import useApiMutation from 'shared/hooks/use-api-mutation';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import deliveryManBillingsKeys from '../util/delivery-man-billings-keys';
import {DeliveryManBillingProps} from '../types';

const usePayDeliveryManBilling = (deliveryManBillingId: string) => {
  const {setData} = useQueryHelpers();
  const {update} = useInfiniteQueryHelpers();

  const onSuccess = (data: DeliveryManBillingProps) => {
    setData(deliveryManBillingsKeys.details(deliveryManBillingId), data);
    update(deliveryManBillingsKeys.list(), data);
  };

  return useApiMutation<{paid: boolean}>({
    url: `/delivery-man-billings/${deliveryManBillingId}/paid`,
    method: 'PATCH',
    errorTitle: 'Erro ao alterar fatura',
    successTitle: 'Alterar fatura',
    successMessage: 'Fatura alterada com sucesso!',
    onSuccess,
  });
};

export default usePayDeliveryManBilling;
